/* eslint-disable react/prop-types */
/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import EdgeDeviceManagementFields from './EdgeDeviceManagementFields'

const EdgeDeviceManagement = (props) => {

  return (
    <MainRouteSubRoutePage mainTitle='routeTitles.edgeDeviceMgmt'>
      <EdgeDeviceManagementFields />
    </MainRouteSubRoutePage>
  )
}

export default EdgeDeviceManagement
